/**
 * Utility functions for price display
 */

/**
 * Format a price amount for display (used in TripCard, SummaryCard, etc.)
 * @param amount - The numeric amount
 * @param isAward - Whether this is an award/points booking
 * @param showCurrency - Whether to show $ or pts suffix (default true)
 */
export function formatPrice(amount: number, isAward: boolean, showCurrency = true): string {
  const rounded = Math.round(amount).toLocaleString();
  if (!showCurrency) return rounded;
  return isAward ? `${rounded} pts` : `$${rounded}`;
}
